// const { data } = await UserLifelineItemControllerService.getLifelineItems([
//   "hl7_fhir_r4_lab_value"
// ]);

import { UserLifelineItemControllerService } from "@9amhealth/openapi";
import { LifeLineItemType } from "./LifeLineItemType";
import { LifeLineSavedMessage } from "./LifeLineSavedMessage";
import reportErrorSentry from "src/lib/reportErrorSentry";
import { brioche } from "@9amhealth/shared";
import { LifeLineItemDetails } from "./LifeLineItemDetails";
import { NavigateFunction } from "react-router-dom";
import Translate from "src/ui/components/Translate/Translate";
import Path from "src/constants/path";
import { LinkButton } from "atom/button/LinkButton";
import { IconCheckmarkWhite } from "src/constants/icons";
import { dismissBrioche } from "src/lib/dismissBrioche";

/**
 * Pre-filters messages based on the data we got from the WebsocketMessage itself
 */
const messagePreFilter: (message: LifeLineSavedMessage) => boolean = ({
  payload: { itemType }
}) => itemType === LifeLineItemType.LAB_VALUE;
/**
 * Fetches extra data to help deciding which actions should be taken.
 */
const messageDecoratorQuery: (
  message: LifeLineSavedMessage
) => Promise<LifeLineItemDetails | null> = async ({ payload: { itemId } }) => {
  try {
    const { data } =
      await UserLifelineItemControllerService.getLifelineItem(itemId);

    const { deserializedPayload } = data;
    return deserializedPayload ?? null;
  } catch (e: unknown) {
    reportErrorSentry(e);
    return null;
  }
};
/**
 * A filter that checks if the actual event was something to deal with. E.g.: BodyWeight from a smart scale
 */
const messageDecoratedFilter: (
  decoration: LifeLineItemDetails | null
) => boolean = (decoration) => {
  if (!decoration) {
    return false;
  }
  if (
    !decoration.observation?.code?.coding?.find(
      ({ code }) => code === "29463-7"
    )
  ) {
    return false;
  }
  return decoration.source?.type === "https://wbsapi.withings.net";
};
/**
 * The message handler function used in the Listener Cubit.
 */
const messageHandler: (args: {
  navigate: NavigateFunction;
  message?: LifeLineSavedMessage;
}) => Promise<void> = async ({ navigate, message }) => {
  if (!message) {
    return;
  }
  if (!messagePreFilter(message)) {
    return;
  }
  const decoration = await messageDecoratorQuery(message);
  if (!messageDecoratedFilter(decoration)) {
    return;
  }

  const { pathname, search } = window.location;

  const needsViewButton = !(
    pathname.includes(`/${Path.app}/${Path.labResults}`) &&
    search.includes("type=29463-7")
  );
  brioche.success({
    icon: <IconCheckmarkWhite />,
    content: <Translate msg={"serverMessage.lifeEventSaved.scaleData"} />,
    controls: needsViewButton ? (
      <LinkButton
        onPress={() => navigate(`/${Path.app}/${Path.labResults}?type=29463-7`)}
      >
        <Translate msg={"view"} />
      </LinkButton>
    ) : undefined,
    dismissFn: dismissBrioche
  });
};

export const serverEventLabResultListenerConstant = {
  messageHandler
};
